import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogomark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	viewBox: "0 0 219.576 166",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M219.111 164.864C209.328 144.308 199.557 123.758 189.791 103.226C189.642 102.887 189.392 102.488 188.981 102.256C188.57 102.024 188.112 101.965 187.57 101.965H153.641C172.576 84.4244 184.658 59.6098 185.432 31.9699C185.474 30.4175 184.211 29.1447 182.651 29.1447H154.498C154.498 68.032 122.939 99.5617 84.0015 99.5617H75.147C86.1035 76.5018 97.0421 53.4418 107.969 30.3699C108.118 30.0071 108.35 29.6264 108.767 29.4004C109.184 29.1744 109.63 29.1506 110.19 29.1506H154.581L154.54 29.0435L138.605 0V0.0118958H79.9584C79.5594 0.0118958 79.2021 0.0416352 78.8865 0.208176C78.5709 0.380665 78.3864 0.660216 78.2673 0.933819C61.4932 36.2643 44.7012 71.6423 27.8973 107.068C18.751 126.327 9.61072 145.592 0.464459 164.864C0.351321 165.078 0.267957 165.304 0.172683 165.548C0.119092 165.69 0.059546 165.839 0 165.994H42.5278C42.8672 166.023 43.2125 165.946 43.4924 165.791C43.7723 165.631 43.9688 165.393 44.0402 165.125C49.6733 153.212 55.2885 141.352 60.8917 129.539C61.0406 129.212 61.2609 128.873 61.642 128.671C62.0231 128.468 62.3566 128.457 62.9342 128.457H156.671C157.255 128.457 157.547 128.48 157.916 128.671C158.285 128.867 158.488 129.17 158.648 129.497C164.264 141.304 169.861 153.117 175.434 164.923C175.548 165.155 175.75 165.512 176.078 165.696C176.405 165.881 176.697 165.905 177.209 165.916H219.576L219.111 164.852V164.864Z",
		fill: "var(--fill-0, #181818)"
	})]
});
const ForwardRef = forwardRef(SvgLogomark);
export { ForwardRef as ReactComponent };
